export const formatCartCountLabel = (cartLabel, count) =>
  `${cartLabel}${count > 0 ? ` (${count})` : ''}`
